// ConfirmDeleteDialog.jsx
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export const dialogPaperSx = {
  '& .MuiDialog-paper': {
    p: 2,
    borderRadius: '8px',
    minWidth: { xs: '300px', sm: '370px' },
    maxWidth: '450px',
  },
};

const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Delete Item",
  message = "Are you sure you want to delete this item?",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
}) => {
  return (
    <Dialog open={open} onClose={onClose} sx={dialogPaperSx}>
      {/* <Box sx={{ p: 2 }}> */}
        <DialogTitle sx={{ fontSize: "1rem", p: 0, fontWeight:"600" }}>{title}</DialogTitle>
        <DialogContent sx={{ px: 0, pt: 0, textAlign: "left" }}>
          <DialogContentText sx={{ p: 0, mt: 2, }}>
            {message}
          </DialogContentText>
        </DialogContent>
         <Box sx={{display:"flex",gap:2, pt:2 }}>
          <Button onClick={onClose} variant='outlined' sx={{width:"50%",  borderRadius: '3px',maxHeight: '35px', borderColor:"#707070"}}>{cancelLabel}</Button>
          <Button onClick={onConfirm}  sx={{width:"50%",  borderRadius: '3px',maxHeight: '35px', backgroundColor: "#E25C5C", '&:hover': { backgroundColor: "#E25C5C" }, color: "white"  }} variant='contained'>{confirmLabel}</Button>
        </Box>
        {/* <DialogActions sx={{ justifyContent: "space-between" }}>
          <Button onClick={onClose} color="primary">
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            sx={{ backgroundColor: "red", '&:hover': { backgroundColor: "red" }, color: "white" }}
          >
            {confirmLabel}
          </Button>
        </DialogActions> */}
      {/* </Box> */}
    </Dialog>
  );
};

export default ConfirmDeleteDialog;